<div class="p-grid p-align-start vertical-container mt-1 container-fullsize">

    <div class="p-col-12  p-col-align-start  " id="tableRelatorioEmails">
        <div class="box text-center shadow-lg p-2 mb-2 bg-white rounded" style="min-height: 450px !important; display: flex; flex-direction: column;">
            <div class=" mx-3 text-left">
                <span class=" mx-4 text-center font-weight-bolder text-success shadow">
                    <h2> Relatório de Envio de E-mails
                        <br>
                    </h2>
                </span>
            </div>

            <div class="mx-2 text-right">
                <button class="btn btn-outline-secondary" (click)="exportParaExcel()" style="margin-right: 9px;"
                    pTooltip="Salvar planilha de emails da eleição">
                    <i class="fas fa-save"></i>
                </button>
            </div>

            <div class="container-filter mt-1 p-2 mb-2 text-left">
                <ul class="px-2">
                    <div class="row">

                        <div class="mb-1 ml-3 mr-2">
                            <label for="loginUsuarioFilter" style="font-weight: bold;">Usuário:</label>
                            <input class="form-control" id="loginUsuarioFilter" type="text" placeholder="Usuário"
                                style="width: 312px;" [(ngModel)]="loginUsuarioFilter" />
                        </div>


                        <div class="mb-1 ml-3 mr-2">
                            <label for="destinatarioFilter" style="font-weight: bold;">Destinatário:</label>
                            <input class="form-control" id="destinatarioFilter" type="text" placeholder="Destinatário"
                                style="width: 350px;" [(ngModel)]="destinatarioFilter" />
                        </div>


                        <div class="mb-1 ml-3 mr-2">
                            <label for="dateFilter" style="font-weight: bold;">Data Envio:</label>
                            <input class="form-control" id="dateFilter" type="date" style="width: 155px;"
                                [(ngModel)]="selectedDate" />
                        </div>


                        <div class="mb-1 ml-3 mr-2">
                            <label for="statusFilter" style="font-weight: bold;">Status:</label>
                            <select class="form-control" id="statusFilter" style="width: 155px;"
                                [(ngModel)]="statusFilter">
                                <option value="">Status</option>
                                <option value="Aberto">Aberto</option>
                                <option value="Entregue">Entregue</option>
                                <option value="Falha">Falha</option>
                                <option value="Enviado">Enviado</option>
                            </select>
                        </div>


                    </div>
                    <div class="row justify-content-end mt-4">
                        <div class="ml-3 mr-2">
                            <button class="btn btn-primary" (click)="applyFilters()">Filtrar</button>
                        </div>

                        <div class="ml-3 mr-3">
                            <button class="btn btn-primary" (click)="cleanFilters()">Limpar</button>
                        </div>
                    </div>
                </ul>
            </div>

            <div class="table-responsive" style="flex: 1;">
                <ul class="px-3">
                    <h4 class="mb-4">Relação de e-mails</h4>
                    <table class="table table-fixed table-bordered">
                        <thead>
                            <tr>
                                <th scope="col" style="width:10%; vertical-align: middle">Usuário</th>
                                <th scope="col" style="width:10%; vertical-align: middle">Tipo Usuário</th>
                                <th scope="col" style="width:10%; vertical-align: middle">Destinatário</th>
                                <th scope="col" style="width:10%; vertical-align: middle">Data Envio</th>
                                <th scope="col" style="width:10%; vertical-align: middle">Hora Envio</th>
                                <th scope="col" style="width:10%; vertical-align: middle">Status</th>
                                <th scope="col" style="width:10%; vertical-align: middle">Data Evento</th>
                                <th scope="col" style="width:10%; vertical-align: middle">Hora Evento</th>
                                <th scope="col" style="width:10%; vertical-align: middle">Visualizar</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let e of filteredEmails | paginate: { itemsPerPage: contador, currentPage: paginaAtual }"
                                [ngClass]="'bntpo'">
                                <td style="vertical-align: middle">{{e.loginUsuario}}</td> <!--Nome eleitor aqui!-->
                                <td style="vertical-align: middle">{{e.tipoUsuario}}</td> <!--Nome eleitor aqui!-->
                                <td style="vertical-align: middle">{{e.destinatario}}</td>
                                <td style="vertical-align: middle">{{separarDataHoraEmail(e).data}}</td>
                                <td style="vertical-align: middle">{{separarDataHoraEmail(e).hora}}</td>
                                <td style="vertical-align: middle" *ngIf="e.eventos.length > 0">{{e.eventos[0].status}}</td>
                                <td style="vertical-align: middle" *ngIf="e.eventos.length == 0"></td>
                                <td style="vertical-align: middle" *ngIf="e.eventos.length > 0">{{separarDataHora(e).data}}</td>
                                <td style="vertical-align: middle" *ngIf="e.eventos.length == 0"></td>
                                <td style="vertical-align: middle" *ngIf="e.eventos.length > 0">{{separarDataHora(e).hora}}</td>
                                <td style="vertical-align: middle" *ngIf="e.eventos.length == 0"></td>
                                <td>
                                    <button type="button" class="btn btn-light" style="margin: 0%; padding: 0%;"
                                        (click)="abrirRelatorioEmailDetalhado(e)" pTooltip="Abrir relatório detalhado">
                                        <i class="far fa-eye"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="text-right" *ngIf="emails.length > 0">
                        <pagination-controls class="ml-auto" (pageChange)="paginaAtual = $event"
                            previousLabel="Anterior" nextLabel="Próximo"></pagination-controls>
                    </div>
                    <hr>
                    <div class="mx-3 text-left">
                        <p>- </p>
                    </div>
                </ul>
            </div>
        </div>
    </div>
</div>